import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/profiles/Page";

export const PATH = "/vendors/settings/profiles";

const ProfileSetting: NextPage = () => (
	<>
		<NskHead title="プロフィール設定" />
		<Component />
	</>
);

export default ProfileSetting;
